import { Observable } from 'rxjs'
import { Apollo } from 'apollo-angular'
import { Injectable } from '@angular/core'
import {
    SendDataRequestFormMutation,
    SendDataRequestFormMutationService,
    SendDataRequestFormMutationVariables,
} from '@app-graphql/schema'

@Injectable({
    providedIn: 'root',
})
export class DataRequestService {

    constructor(
        private readonly sendDataRequestFormMutationService: SendDataRequestFormMutationService,
    ) {
    }

    public sendDataRequestForm(input: SendDataRequestFormMutationVariables)
        : Observable<Apollo.MutateResult<SendDataRequestFormMutation>> {
        return this.sendDataRequestFormMutationService.mutate({
            variables: input,
            errorPolicy: 'all',
        })
    }
}
